import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Utilities } from "./utilities";

@Injectable()
export class EmbedService {

  public action = "edit";

  constructor(
    private afdb: AngularFireDatabase,
    private utilities: Utilities,
  ) { }

  public getEmbedList(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Embed`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Events/${eventId}/Embed`;
    }
    return this.afdb.list<any>(ref).valueChanges();
  }

  public getEmbedItem(clientId: string, embedId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Embed/${embedId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Events/${eventId}/Embed/${embedId}`;
    }
    return this.afdb.object<any>(ref).valueChanges();
  }

  public createOrEditEmbed(clientId: string, embedInfo: any) {
    if (!embedInfo.id) {
      embedInfo.id = this.utilities.generateRamdomKey()
      this.action = "create";
    }

    let ref = `Clients/${clientId}/Embed/${embedInfo.id}`;
    if (this.utilities.validateEventIdParam(embedInfo.eventId)) {
      ref = `Clients/${clientId}/Events/${embedInfo.eventId}/Embed/${embedInfo.id}`;
    }

    return new Promise((res, rej) => {
      this.afdb.database
        .ref(ref)
        .set(embedInfo)
        .then(() => {
          return res(embedInfo.id);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/embed.service.ts